var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{ref:"fileInputRef",staticStyle:{"display":"none"},attrs:{"type":"file","accept":".xlsx,.xls"},on:{"change":_setup.handleFileChange}}),_c('v-btn',{class:_vm.className,attrs:{"small":"","color":"success"},on:{"click":_setup.triggerFileDialog}},[_vm._v(" 엑셀 비교 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }